import { render, staticRenderFns } from "./GlobalVariablesInput.vue?vue&type=template&id=b4225a08&"
import script from "./GlobalVariablesInput.vue?vue&type=script&lang=ts&"
export * from "./GlobalVariablesInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports